import React, {useState, useEffect} from 'react';
import style from "./Loader.module.scss";

export default function Loading(props: {companyName: string, duration: number}) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const startTime = Date.now();

        const updateProgress = () => {
            const elapsed = Date.now() - startTime;
            const currentProgress = Math.min((elapsed / props.duration) * 100, 100);
            setProgress(currentProgress);

            if (currentProgress < 100) {
                requestAnimationFrame(updateProgress);
            }
        };

        requestAnimationFrame(updateProgress);
    }, []);

    return (
        <div className={style.loadingContainer}>
            <div className={style.loadingWrapper}>
                {/* Фоновый текст (серый) */}
                <div className={style.backgroundText}>{props.companyName}</div>

                {/* Передний план с анимацией (зеленый текст) */}
                {/*// Ширина зависит от прогресса*/}
                <div
                    className={style.foregroundWrapper}
                    style={{ width: `${progress}%` }}>
                    <div className={style.foregroundText}>{props.companyName}</div>
                </div>
                {/* Прогресс в процентах */}
                <div className={style.progressText}>{Math.round(progress)}%</div>
            </div>
        </div>
    );
};
